<template>
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group" 
    v-show="showPOIFilter">
    <button
      @click="$store.dispatch('sightmapevent/inqueueMapEvent', {
        event: 'handleShowSetting'
      })"
      class="mapboxgl-ctrl-icon"
      aria-label="Filter"
    ><i class="fas fa-filter" style="transform: scale(1.1);"></i></button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'sight-map-settting-btn',
  uit() {
    return [
      ['action', ['filter']]
    ]
  },
  computed: {
    ...mapState({
      showPOIFilter: state => state.geolocation.showPOIFilter
    })
  }
}
</script>
